export const APPOINTMENTS_GRID_COLUMNS = '160px 1fr 130px 100px 20px';
export const PAYMENTS_GRID_COLUMNS = '1fr 130px 20px';
export const FORMS_GRID_COLUMNS = '1fr 150px 90px';
